import './index.scss';
import { useModalData } from '../../../store/modal/modalHooks';
import DashboardAdModalContent from '../../pages/dashboard/DashboardAdModalContent';

const DashboardAdModal = () => {
  const modalData = useModalData();
  const link = modalData?.data?.link;

  return (
    <div className="dashboard-ad-modal">
      <div className="dashboard-ad-modal-video">
        <DashboardAdModalContent link={link}/>
      </div>
    </div>
  );
};

export default DashboardAdModal;
